import apiFn from 'common/services/api-service';

const api = () => apiFn('/api/cms/v1');

export const listOrganizations = async (params = {}) => {
  const { search = '', limit, page = '0', sort = '-created_at', ...otherParams } = params;

  const query = {
    limit: parseInt(limit.toString(), 10),
    offset: parseInt(page, 10) * parseInt(limit.toString(), 10),
    sort,
    ...otherParams,
  };

  if (search && search.trim()) {
    query.search = search.trim();
  }

  return api()
    .get('/views/admin-list-organizations', { params: query })
    .then(response => response.data);
};

export const createOrganization = async payload =>
  api()
    .post('/action/admin-create-organization', payload)
    .then(response => response.data);
